export * from './slide-toggle';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@angular/material/slide-toggle/index.js
// module id = ../../../material/slide-toggle/index.js
// module chunks = 3